import HeadTitle from './HeadTitle'
export default HeadTitle
